import React from 'react';
import { Card, List, Row, Typography } from 'antd';
import { AimOutlined, PlusOutlined } from '@ant-design/icons';
import Button from "@common/Button";
import EditableSectionDevelopment from "./EditableSectionDevelopment";

const { Title, Text } = Typography;

const LearningObjectivesCard = ({
    objectives,
    isEditMode,
    editingState,
    adaptedKeys,
    handleEdit,
    handleContentChange,
    handleSave,
    handleCancel,
    handleAddListItem,
    handleRemoveListItem
}) => {
    return (
        <div id="lesson-objectives">
            <Card size="small">
                <Row justify="space-between" align="middle" style={{marginBottom: '8px'}}>
                    <Title level={4} style={{marginTop: 0, marginBottom: 0}}><AimOutlined /> Learning Objectives</Title>
                    {isEditMode && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() => handleAddListItem('objectives', 'New objective. Click to edit.', 'Objective')}
                        >
                            Add Objective
                        </Button>
                    )}
                </Row>
                <List
                    size="small"
                    dataSource={objectives}
                    renderItem={(item, itemIndex) => (
                        <List.Item>
                            {(() => {
                                const isEditingThisOne = editingState.key === `objectives.${itemIndex}`;
                                return (
                                    <EditableSectionDevelopment
                                        contentKey={`objectives.${itemIndex}`}
                                        editContent={isEditingThisOne ? editingState.content : item}
                                        isEditing={isEditingThisOne}
                                        isAdapted={adaptedKeys.has(`objectives.${itemIndex}`)}
                                        onEdit={isEditMode ? handleEdit : undefined}
                                        onChange={isEditMode ? handleContentChange : undefined}
                                        onSave={isEditMode ? handleSave : undefined}
                                        onCancel={isEditMode ? handleCancel : undefined}
                                        onDelete={isEditMode ? () => handleRemoveListItem('objectives', itemIndex, item) : undefined}
                                        deleteTooltip="Remove objective"
                                    >
                                        <Text>{item}</Text>
                                    </EditableSectionDevelopment>
                                );
                            })()}
                        </List.Item>
                    )}
                />
            </Card>
        </div>
    );
};

export default LearningObjectivesCard;
